var React = require("react");
const PropTypes = require('prop-types');

var TextArea = function(props) {
	return (
		<textarea
			id={props.id ? props.id : null}
			className="form-control"
			rows={props.rows ? props.rows : "10"}
			name={props.name ? props.name : null}
			value={props.value}
			onChange={props.onChange}
			disabled={props.disabled}
		/>
	);
};

TextArea.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};

module.exports = TextArea;
